import { defaultFujiProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/fuji/default-constants';

export const PANGOLIN_FUJI_CONTRACT_ADDRESS = '0x2D99ABD9008Dc933ff5c0CD271B88309593aB921';

export const PANGOLIN_FUJI_PROVIDER_CONFIGURATION = defaultFujiProviderConfiguration;
